import React from 'react'
import PropTypes from 'prop-types'
import {TabButtonBox} from 'hec/components/content-tabs'

export const BuilderTabButtonBox = (props) => {
    return <TabButtonBox {...props} />
}

BuilderTabButtonBox.propTypes = {
    attributes: PropTypes.object,
    content: PropTypes.arrayOf(PropTypes.object),
    builderBlock: PropTypes.object,
    'data-testid': PropTypes.string
}

export const TabButtonBoxDefinition = {
    component: BuilderTabButtonBox,
    name: 'Tab Button',
    noWrap: true,
    canHaveChildren: true,
    shouldReceiveBuilderProps: {
        builderBlock: true
    },
    inputs: [
        {
            name: 'content',
            type: 'uiBlocks',
            defaultValue: []
        }
    ]
}
